import React from 'react';
import Chip from '@mui/material/Chip';

const ChipEx = (props) => {
  return (
    <Chip
      variant={props.variant}
      size={props.size || 'small'}
      label={props.label}
      style={{...props.style}}
      color={props.color}
      onClick={() => {
        if( props.onClick ) props.onClick();
      }}
      sx={{
        height: props.height || '20px',
        position: 'relative',
        top: '-2px',
        '& .MuiChip-label': {
          display: 'block',
          whiteSpace: 'normal',
        },
      }}
    />
  );
};

export default ChipEx;